"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
const SOFT_SHADOW = "shadow-[0_3.4px_2.7px_-30px_rgba(0,0,0,0.06),0_8.2px_8.9px_-30px_rgba(0,0,0,0.07),0_25px_40px_-30px_rgba(0,0,0,0.2)]";
const HOVER_LIFT = "transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:-translate-y-[7.5px]";
export interface LaravelWorkProject {
  id: string;
  title: string;
  domainUrl: string;
  url: string;
  image: string;
  alt: string;
  cardBg: string;
  darkCardBg?: string;
}
export const laravelWorkProjects: LaravelWorkProject[] = [{
  id: "suruchira",
  title: "Suruchira",
  domainUrl: "www.suruchira.com",
  url: "https://www.suruchira.com",
  image: "/images/shopify/suruchira.png",
  alt: "Suruchira website showcase",
  cardBg: "bg-[#fceeed]",
  darkCardBg: "dark:bg-[#20181c]"
}, {
  id: "jewelled-by-vandana",
  title: "Jewelled by Vandana",
  domainUrl: "www.jewelledbyvandana.com",
  url: "https://www.jewelledbyvandana.com",
  image: "/images/shopify/jewelledbyvandana.png",
  alt: "Jewelled by Vandana website showcase",
  cardBg: "bg-[#f4eef9]",
  darkCardBg: "dark:bg-[#1e1724]"
}, {
  id: "vastralipi",
  title: "Vastralipi",
  domainUrl: "www.vastralipi.com",
  url: "https://www.vastralipi.com",
  image: "/images/shopify/vastralipi.png",
  alt: "Vastralipi website showcase",
  cardBg: "bg-[#fdf0f0]",
  darkCardBg: "dark:bg-[#221819]"
}, {
  id: "health-wellness",
  title: "Health Wellness",
  domainUrl: "www.healthnwellness.shop",
  url: "https://www.healthnwellness.shop",
  image: "/images/shopify/healthnwellness.png",
  alt: "Health Wellness website showcase",
  cardBg: "bg-[#eef8f5]",
  darkCardBg: "dark:bg-[#14221e]"
}, {
  id: "necked-jeans",
  title: "Necked Jeans",
  domainUrl: "www.neckedjeans.com",
  url: "https://www.neckedjeans.com",
  image: "/images/shopify/necked.png",
  alt: "Necked Jeans website showcase",
  cardBg: "bg-[#eef3f9]",
  darkCardBg: "dark:bg-[#161e27]"
}, {
  id: "tarohi-jewels",
  title: "Tarohi Jewels",
  domainUrl: "www.tarohijewels.com",
  url: "https://www.tarohijewels.com",
  image: "/images/shopify/tarohi.png",
  alt: "Tarohi Jewels website showcase",
  cardBg: "bg-[#edf8f5]",
  darkCardBg: "dark:bg-[#14221e]"
}, {
  id: "toyz-hub",
  title: "Toyz Hub",
  domainUrl: "www.toyzhub.in",
  url: "https://www.toyzhub.in",
  image: "/images/shopify/toyzhub.png",
  alt: "Toyz Hub website showcase",
  cardBg: "bg-[#edf8f9]",
  darkCardBg: "dark:bg-[#142125]"
}, {
  id: "casevilla",
  title: "Casevilla",
  domainUrl: "www.thecasevilla.com",
  url: "https://www.thecasevilla.com",
  image: "/images/shopify/casevilla.png",
  alt: "Casevilla website showcase",
  cardBg: "bg-[#f5f0fb]",
  darkCardBg: "dark:bg-[#1b1722]"
}];
interface LaravelOurWorkProps {
  heading?: string;
  subtitle?: string;
  badgeImage?: string;
  badgeAlt?: string;
  projects?: LaravelWorkProject[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function LaravelOurWork(t0) {
  const $ = _c(25);
  const {
    heading: t1,
    subtitle: t2,
    badgeImage,
    badgeAlt: t3,
    projects: t4,
    buttonText: t5,
    buttonHref: t6,
    className: t7
  } = t0;
  const heading = t1 === undefined ? "Our Journey of Success with Laravel and Our Clients" : t1;
  const subtitle = t2 === undefined ? "Check out our Laravel development service case studies that show how we helped clients stay ahead in the competitive business world with domain knowledge and technical expertise." : t2;
  const badgeAlt = t3 === undefined ? "Experts" : t3;
  const projects = t4 === undefined ? laravelWorkProjects : t4;
  const buttonText = t5 === undefined ? "View All Projects" : t5;
  const buttonHref = t6 === undefined ? "/our-work" : t6;
  const className = t7 === undefined ? "" : t7;
  const desktopAnimations = useDesktopAnimations();
  const t8 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="pointer-events-none absolute inset-0 bg-[url('/images/shape/dot_bg.png')] bg-left-top bg-repeat opacity-100 dark:opacity-40" aria-hidden="true" />;
    $[0] = t9;
  } else {
    t9 = $[0];
  }
  let t10;
  if ($[1] !== badgeAlt || $[2] !== badgeImage || $[3] !== desktopAnimations || $[4] !== heading || $[5] !== subtitle) {
    t10 = badgeImage ? <div className="mb-12 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end md:mb-16"><motion.div initial={desktopAnimations ? {
        opacity: 0,
        y: 24
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }}><h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>{subtitle && <p className="font-sans mt-2 text-[15px] font-normal text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>}</motion.div><motion.div initial={desktopAnimations ? {
        opacity: 0,
        scale: 0.95
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        scale: 1
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="flex items-center gap-2.5 self-start sm:self-auto"><div className="inline-flex items-center justify-center dark:rounded-full dark:bg-white dark:px-4 dark:py-1.5 dark:shadow-[0_2px_15px_rgba(255,255,255,0.12)]"><Image src={badgeImage} alt={badgeAlt} width={200} height={48} loading="lazy" className="h-10 w-auto max-w-[200px] object-contain sm:h-12 dark:h-8 dark:max-w-[180px] dark:sm:h-9" /></div></motion.div></div> : <div className="mb-12 grid grid-cols-1 items-center gap-6 lg:grid-cols-12 md:mb-16"><motion.div initial={desktopAnimations ? {
        opacity: 0,
        y: 24
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="lg:col-span-7"><h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2></motion.div>{subtitle && <motion.div initial={desktopAnimations ? {
        opacity: 0,
        y: 24
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="lg:col-span-5"><p className="font-sans text-[15px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p></motion.div>}</div>;
    $[1] = badgeAlt;
    $[2] = badgeImage;
    $[3] = desktopAnimations;
    $[4] = heading;
    $[5] = subtitle;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== desktopAnimations || $[8] !== projects) {
    let t12;
    if ($[10] !== desktopAnimations) {
      t12 = (project, index) => {
        const isExternal = /^https?:\/\//.test(project.url || "");
        const card = <div className={HOVER_LIFT}><div className={`relative block w-full overflow-hidden rounded-lg ${project.cardBg} ${SOFT_SHADOW} ${project.darkCardBg || "dark:bg-[#141414]"}`}><Image src={project.image} alt={project.alt || project.title} width={1372} height={914} loading="lazy" className="h-auto w-full object-contain" /></div><div className={`relative -top-10 mx-auto w-[95%] rounded-bl-lg rounded-br-lg rounded-tl-[40px] rounded-tr-lg bg-white p-[15px] text-center ${SOFT_SHADOW} dark:bg-[#181818]`}><h3 className="font-poppins text-lg font-semibold leading-9 text-[#050748] sm:text-[22px] sm:leading-10 dark:text-[#e6e6e6]">{project.title}</h3><p className="font-open-sans text-[15px] leading-7 text-[#6a6a8e] sm:text-[17px] dark:text-slate-400">{project.domainUrl}</p></div></div>;
        return <motion.article key={project.id} initial={desktopAnimations ? {
          opacity: 0,
          y: 40
        } : false} whileInView={desktopAnimations ? {
          opacity: 1,
          y: 0
        } : undefined} animate={desktopAnimations ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.7,
          delay: index % 2 * 0.12,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="group relative">{project.url ? isExternal ? <a href={project.url} target="_blank" rel="noopener noreferrer" className="block">{card}</a> : <Link href={project.url} className="block">{card}</Link> : card}</motion.article>;
      };
      $[10] = desktopAnimations;
      $[11] = t12;
    } else {
      t12 = $[11];
    }
    t11 = projects.map(t12);
    $[7] = desktopAnimations;
    $[8] = projects;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[12] !== t11) {
    t12 = <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2">{t11}</div>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== buttonHref || $[15] !== buttonText || $[16] !== desktopAnimations) {
    t13 = buttonText && <motion.div initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="mt-14 flex justify-center text-center md:mt-18"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></motion.div>;
    $[14] = buttonHref;
    $[15] = buttonText;
    $[16] = desktopAnimations;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t10 || $[19] !== t12 || $[20] !== t13) {
    t14 = <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-8">{t10}{t12}{t13}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t8) {
    t15 = <section className={t8}>{t9}{t14}</section>;
    $[22] = t14;
    $[23] = t8;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
}